import API from '@/services/api';

export default {
  namespaced: true,
  state: {
    list: [],
  },
  actions: {
    async ['contacts:send'](state, contactData) {
      try {
        await API.sendContacts(contactData);
      } catch (err) {
        console.error(err);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/contactUs/index.js